"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=attributes.js.map